import { Block as e } from "../../components/FocusBlock.es.js";
import { jsx as t } from "react/jsx-runtime";
//#region lib/Table/components/Table.tsx
var n = ({ editor: n, element: r, children: i }) => /* @__PURE__ */ t(e, {
	editor: n,
	element: r,
	children: /* @__PURE__ */ t("table", {
		className: "w-full border table-fixed border-separate rounded border-spacing-0 m-0 p-0",
		children: /* @__PURE__ */ t("tbody", { children: i })
	})
});
//#endregion
export { n as Table };
